import React from 'react';
import { InviteButton } from 'features/invite/components/add-people-dialog/web/InviteButton';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from 'jitsi/base/environment/utils';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles()((theme, { isMobile }) => ({
    container: {
        zIndex: 1,
        marginTop: isMobile ? theme.spacing(4) : 0,
    },
    text: {
        marginTop: `${theme.spacing(6)} !important`,
        marginBottom: theme.spacing(3),
        fontWeight: 600,
        color: theme.palette.iisightWhite,
        textAlign: 'center',
    },
    buttonContainer: {
        width: 200,
        maxWidth: '100%',
        margin: '0 auto',
    },
}));
const isMobile = isMobileBrowser();
export const ConferenceInvitation = () => {
    const { classes } = useStyles({ isMobile });
    const { t } = useTranslation();
    return (React.createElement("div", { className: classes.container }, window.APP.isMeetingAuditor ? (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement("h4", { className: classes.text, style: { marginBottom: '0px' } }, t('auditor.attendedAs')),
        React.createElement("h4", { className: classes.text }, t('auditor.noOneCanHear')))) : (React.createElement(React.Fragment, null,
        React.createElement("h3", { className: classes.text }, t('addPeople.inviteMoreHeader')),
        React.createElement("div", { className: classes.buttonContainer },
            React.createElement(InviteButton, null))))));
};
